/// <amd-module name="Analytics/Boards/VelocityQueries/MetastateByIterationDetailsQuery" />
import { WorkItemWithState } from "Analytics/Boards/BoardsQueries/DataContracts";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { QueryUtilities } from "Analytics/Common/Utilities/QueryUtilities";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";
import { VelocityQueryBase } from "./VelocityQueryBase";

export class MetastateByIterationDetailsQuery extends VelocityQueryBase<WorkItemWithState[]> {
    private static generateQueryOptions(iterationId: string, projectId: string, teamId: string, workItemTypes: string[]): ODataQueryOptions {
        // $apply
        const iterationsClause = QueryUtilities.isInArray("IterationSK", [iterationId]);

        const workItemTypeClause = QueryUtilities.isInArray("WorkItemType", workItemTypes, true /* useQuotes */);

        const $apply =
            `filter(` +
            `Teams/any(t:t/TeamSK eq ${teamId})` +
            ` and (${workItemTypeClause})` +
            ` and (${iterationsClause})` +
            ` and StateCategory ne null)`;

        return {
            entityType: "WorkItems",
            oDataVersion: latestODataVersion,
            project: projectId,
            $apply: $apply,
            $select: "WorkItemId, StateCategory, State"
        };
    }
    private queryName?: string;

    constructor(command: string, iterationId: string, projectId: string, teamId: string, workItemTypes: string[], queryName?: string) {
        super(command, MetastateByIterationDetailsQuery.generateQueryOptions(iterationId, projectId, teamId, workItemTypes));
        this.queryName = queryName;
    }

    public getQueryName(): string {
        return this.queryName || "MetastateByIterationDetailsQuery";
    }
}
